import clsx from "clsx";
import { FC, HTMLAttributes, ReactNode } from "react";

import styles from "./styles.module.css";

export interface AccordionSummaryProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  imageUrl?: string;
  title: ReactNode;
  description?: string | string[];
  callout?: ReactNode;
}

export const AccordionSummary: FC<AccordionSummaryProps> = ({
  callout,
  className,
  description,
  imageUrl,
  title,
  ...props
}) => {
  const buildDescription = () => {
    if (Array.isArray(description)) {
      return description.join(" • ");
    }
    return description;
  };

  return (
    <div className={clsx([styles.accordionSummary, className])} {...props}>
      {imageUrl && <img className={styles.avatar} src={imageUrl} alt="" />}
      <div className={styles.text}>
        <div className={styles.title}>{title}</div>
        {description && (
          <p className={styles.description}>{buildDescription()}</p>
        )}
      </div>
      {callout && <div className={styles.callout}>{callout}</div>}
    </div>
  );
};
